import subDays from "date-fns/subDays";

import dateToUTC from "./dateToUTC";
import setDateTime from "./setDateTime";

const getSaleDate = (date: Date, days: number, time: string) =>
  dateToUTC(setDateTime(subDays(date, days), time));

export default getSaleDate;
